import Action from '../Action';
import TagsService from '../../services/TagsService';
import { message } from 'antd';

export function fetchTags() {
	return (dispatch) => {
		TagsService.get()
			.then((tags) => dispatch({ type: Action.FETCH_TAGS, tags: tags.data }))
			.catch((error) => message.error('Failed to fetch tags!'));
	};
}

export function addTag(body) {
	return (dispatch) => {
		TagsService.add(body)
			.then((tags) => {
				dispatch({ type: Action.POST_TAG, tags: tags.data });
				message.success('Tag added');
			})
			.catch((error) => message.error('Failed to add Tag!'));
	};
}

export function updateTag(id, body) {
	return (dispatch) => {
		TagsService.update(id, body)
			.then((tags) => {
				dispatch({ type: Action.UPDATE_TAG, tags: tags.data });
				message.success('Tag Updated');
			})
			.catch((error) => message.error('Failed to edit Tag!'));
	};
}

export function deleteTag(id) {
	return (dispatch) => {
		TagsService.delete(id)
			.then((tags) => {
				dispatch({ type: Action.DELETE_TAG, tags: tags.data });
				message.success('Tag Deleted');
			})
			.catch((error) => message.error('Failed to delete Tag!'));
	};
}
